import { motion } from "framer-motion";
import { FADE_UP } from "@/lib/motion";
import { useLivePrices, PriceRow } from "@/components/prices/LivePrices";
import { NetworkDisclosure, TestTokenNote } from "@/components/common/TestTokenNote";

export default function PricesPage() {
  const { rows, loading, updatedAt } = useLivePrices();
  return (
    <div data-testid="prices-page" className="max-w-2xl mx-auto px-4 sm:px-6 py-12">
      <motion.div {...FADE_UP}>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mb-3">
          Live <span className="text-[#D4AF37]">prices</span>
        </h1>
        <p className="text-zinc-400 mb-3">Current prices of FMI, USDT, FBTC and every listed FSC token, refreshed every 30 seconds, with 24-hour charts.</p>
        <TestTokenNote testId="prices-token-note" />
      </motion.div>
      <div className="space-y-3 mt-8">
        {rows.map((r) => <PriceRow key={r.symbol} row={r} />)}
      </div>
      <p data-testid="prices-updated" className="text-xs text-zinc-600 mt-3">
        {loading ? "Loading prices…" : `Updated ${new Date(updatedAt).toLocaleTimeString()}`}
      </p>
      <div data-testid="prices-other-networks" className="mt-8 p-4 rounded-lg border border-[#2A2411] bg-[#0A0A0A]">
        <p className="text-sm font-medium text-white mb-1">FMI on other networks</p>
        <p className="text-xs text-zinc-400 leading-relaxed">
          The FMI price above is for the native coin of FMI Smart Chain (chain 77177) only. FMI COIN on BNB Chain is a separate token with its own,
          different market price. Do not use the FSC price to value BNB Chain FMI.
        </p>
        <a data-testid="prices-bnb-fmi-link" href="https://firstmahicrypto.com/trade/FMI-USDT?chain=56" target="_blank" rel="noreferrer"
          className="inline-block mt-2 text-sm text-[#D4AF37] hover:underline">See FMI COIN (BNB Chain) on firstmahicrypto.com</a>
      </div>
      <div className="mt-8 p-4 rounded-lg border border-[#2A2411] bg-[#0A0A0A]">
        <p className="text-sm font-medium text-white mb-1">Public price feed</p>
        <p className="text-xs text-zinc-500 mb-2">Sites and bots can read these prices as JSON. Free, no key needed; please poll no more than every 30 seconds.</p>
        <a data-testid="prices-feed-link" href={`${window.location.origin}/api/v1/prices`} target="_blank" rel="noreferrer"
          className="font-mono text-sm text-[#D4AF37] hover:underline break-all">{`${window.location.origin}/api/v1/prices`}</a>
      </div>
      <div className="mt-8 p-4 rounded-lg border border-amber-500/30 bg-amber-500/5">
        <p className="text-sm font-medium text-amber-300 mb-2">Important</p>
        <NetworkDisclosure testId="prices-network-disclosure" className="text-sm text-zinc-300" />
      </div>
    </div>
  );
}
